import { IconWrapper } from '../runtime';
export default IconWrapper('tilting-bar-right', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("g", [h("path", {
    "attrs": {
      "vector-effect": "non-scaling-stroke",
      "d": "M8.24407 13.7508H2.94647C2.28373 13.7508 1.74647 13.2135 1.74647 12.5508L1.74649 3.4478C1.74649 2.78506 2.28375 2.2478 2.94649 2.2478H8.24408M8.24407 13.7508H13.049C13.7117 13.7508 14.249 13.2135 14.249 12.5508L14.249 3.4478C14.249 2.78506 13.7118 2.2478 13.049 2.2478H8.24408M8.24407 13.7508L8.24408 2.2478M12.249 5.25118H10.249M12.249 7.9996H10.249M12.249 10.7477H10.249",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin
    }
  })])]);
});